import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Infinite from 'react-infinite';
import { injectIntl, defineMessages } from 'react-intl';

import { Image } from 'semantic-ui-react';

import { CtExamHeader, CtExamChart } from 'containers';
import { ExamListItemAll, ExamListItemPi, ExamListItemTag, Loading, ModalExamAddTag, ExamSearch } from 'components';

import styles from './ExamList.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      currentPath,
      beforePath,
      selectedExamSummaryNo,
      selectedExamList,
      examListOrdering,
      examListByNo,
      examSummaryByExamNo,
      scrollData,
      isModal,
      isLoading,
      examListParam,
      page,
      totalPage,
      tagDataByTagNo,
      sendLogData,
      dropDirection,
      takeSearchValue,
      tempFilter
    } = this.props;
    // function
    const {
      onGetExamList,
      onRefScroll,
      handleSelectExamList,
      handleCheckExamList,
      // 검색용 Props
      examSearchProps
    } = this.props;

    const { loadingExamDelete, onExamDeleteModal } = this.props;

    // 훈련 결과 현재 탭
    const examSubTab =
      (selectedExamSummaryNo === 'all' && 'all') ||
      (currentPath === '/main/exam/pi' && 'pi') ||
      (currentPath === '/main/exam/tag' && 'tag');

    const ExamListItemComponent = examListOrdering.map((itemNo, index) => {
      const selectItem = examSummaryByExamNo.get(String(examListByNo.getIn([String(itemNo), 'examNo'])));

      if (examSubTab === 'all') {
        if (!!examSummaryByExamNo.get(String(itemNo))) {
          return (
            <ExamListItemAll
              key={index}
              indexNo={index}
              itemNo={itemNo}
              examListData={examListByNo.get(String(itemNo))}
              examSummaryData={examSummaryByExamNo.get(String(itemNo))}
              selectedExamList={selectedExamList}
              handleSelectExamList={handleSelectExamList}
              handleCheckExamList={handleCheckExamList}
            />
          );
        }
      } else if (selectedExamSummaryNo === examListByNo.getIn([String(itemNo), 'examNo'])) {
        if (examSubTab === 'pi' && !!examListByNo.getIn([String(itemNo), 'targetNo']) && !!selectItem) {
          return (
            <ExamListItemPi
              key={index}
              itemNo={itemNo}
              examListData={examListByNo.get(String(itemNo))}
              examSummaryData={selectItem}
              selectedExamList={selectedExamList}
              sendLogData={sendLogData}
              handleSelectExamList={handleSelectExamList}
            />
          );
          // } else if (examSubTab === 'tag' && !!examListByNo.getIn([String(itemNo), 'tagNo'])) {
        } else if (examSubTab === 'tag') {
          if (!!examListByNo.getIn([String(itemNo), 'tagNo']) && !!selectItem) {
            const examTagTarget = examSummaryByExamNo.getIn([
              String(examListByNo.getIn([String(itemNo), 'examNo'])),
              'examTagTarget'
            ]);

            return (
              <ExamListItemTag
                key={index}
                itemNo={itemNo}
                // 훈련 내릴때 선택한 태그
                isExamTag={examTagTarget && examTagTarget.split(',').indexOf(String(itemNo)) !== -1 ? true : false}
                examListData={examListByNo.get(String(itemNo))}
                examSummaryData={selectItem}
                selectedExamList={selectedExamList}
                tagDataByTagNo={tagDataByTagNo}
                handleSelectExamList={handleSelectExamList}
              />
            );
            // 태그가 없는 대상자
          } else {
            // return (
            //   <ExamListItemTag
            //     key={index}
            //     itemNo={itemNo}
            //     // 훈련 내릴때 선택한 태그
            //     isExamTag={false}
            //     examListData={examListByNo.get(String(itemNo))}
            //     selectedExamList={selectedExamList}
            //     tagDataByTagNo={tagDataByTagNo}
            //     handleSelectExamList={handleSelectExamList}
            //   />
            // );
          }
        }
      }

      return false;
    });

    const EmptyComponent =
      examSubTab === 'all' ? (
        <div className={cx('noScroll', 'noTarget')}>
          <div className={cx('noScroll-title')}>
            {defineMessages(formatMessage({ id: 'ExamList_1', defaultMessage: '훈련이 없습니다' }))}
          </div>
          <div className={cx('noScroll-subTitle')}>
            {defineMessages(formatMessage({ id: 'ExamList_2', defaultMessage: '훈련을 실행해 보세요!' }))}
          </div>
        </div>
      ) : (
          <div className={cx('noScroll', 'noTarget')}>
            <div className={cx('noScroll-icon-area')}>
              <Image src="/img/exam/list_noTarget.png" />
            </div>
            <div className={cx('')}>
              <div className={cx('noScroll-title')}>
                {examSubTab === 'tag'
                  ? defineMessages(formatMessage({ id: 'ExamList_3', defaultMessage: '태그가 없습니다' }))
                  : defineMessages(formatMessage({ id: 'Target_15', defaultMessage: '대상자가 없습니다' }))}
              </div>
              <div className={cx('noScroll-subTitle')}>
                {/* {defineMessages(formatMessage({ id: 'ExamList_2', defaultMessage: '훈련을 실행해 보세요' }))} */}
              </div>
            </div>
          </div>
        );

    return (
      <div className={cx('exam-wrapper')}>
        <CtExamHeader onGetExamList={onGetExamList} />
        <CtExamChart />
        <div className={cx('exam-content')}>
          {/* 태그 만들기 모달 */}
          {isModal === 'examAddTag' && (
            <ModalExamAddTag
              visible
              isClicked={examSearchProps.isClicked}
              examNo={selectedExamSummaryNo}
              examName={examSummaryByExamNo.getIn([String(selectedExamSummaryNo), 'examName'])}
              onAddTag={examSearchProps.onAddTag}
              onToggleModal={examSearchProps.onToggleModal}
              filter={examListParam.get('filter')}
            />
          )}
          <ExamSearch
            className={cx('ExamList-search')}
            examNo={selectedExamSummaryNo}
            examListParam={examListParam}
            examSubTab={examSubTab}
            dropDirection={dropDirection}
            examSearchProps={examSearchProps}
            selectedExamList={selectedExamList}
            examType={examSummaryByExamNo.getIn([String(selectedExamSummaryNo), 'examType'])}
            onToggleModal={examSearchProps.onToggleModal}
            loadingExamDelete={loadingExamDelete}
            onExamDeleteModal={onExamDeleteModal}
            takeSearchValue={takeSearchValue}
            isModal={isModal}
            searchTextRef={examSearchProps.searchTextRef}
            tempFilter={tempFilter}
          />
          {isLoading && (<div className={cx('Loading')}>
            <Loading content={'Loading...'} />
          </div>)}
          <div className={cx('exam-content-inner')}>
            {ExamListItemComponent.size > 0 && !!ExamListItemComponent.get(0) ? (
              // <Infinite
              //   className={cx({ noScroll: !scrollData['isScroll'] })}
              //   ref={Infinite => {
              //     onRefScroll(Infinite);
              //   }}
              //   containerHeight={scrollData['height']}
              //   elementHeight={47}
              //   infiniteLoadBeginEdgeOffset={200}
              //   timeScrollStateLastsForAfterUserScrolls={1000}
              //   onInfiniteLoad={page !== totalPage ? onGetExamList : () => {}}
              //   loadingSpinnerDelegate={
              //     isLoading && (
              //       <div className={cx('Loading')}>
              //         <Loading content={'Loading...'} />
              //       </div>
              //     )
              //   }
              //   isInfiniteLoading={isLoading}>
              //   {ExamListItemComponent}
              // </Infinite>
              <div className={'exam-list-component'} ref={scroll => this.props.scrollRef(scroll)} onScroll={this.props.onScroll}>
                {ExamListItemComponent}
              </div>
            ) : (
                EmptyComponent
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ExamList);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamList.js